'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.shouldAllowBackwardTab = exports.shouldAllowForwardTab = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = manageFocus;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _tabbable = require('tabbable');

var _tabbable2 = _interopRequireDefault(_tabbable);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

var _utilsAccessibility = require('@bibliocommons/utils-accessibility');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TAB_KEYCODE = 9;

/**
 * Returns true if nodeA comes after nodeB in the DOM
 */
var nodeIsAfter = function nodeIsAfter(nodeA, nodeB) {
  return !!(nodeA.compareDocumentPosition(nodeB) & Node.DOCUMENT_POSITION_PRECEDING);
}; // eslint-disable-line no-bitwise

/**
* Returns true if nodeA comes before nodeB in the DOM
*/
var nodeIsBefore = function nodeIsBefore(nodeA, nodeB) {
  return !!(nodeA.compareDocumentPosition(nodeB) & Node.DOCUMENT_POSITION_FOLLOWING);
}; // eslint-disable-line no-bitwise


var isSameTabbableElement = function isSameTabbableElement(target, compareTo) {
  if (target === compareTo) {
    return true;
  }

  // Radio buttons are in the same tabbable group but there are special rules to determine which can be tabbed to
  // We don't care about those and just want to know if the whole group is the first or last element
  if (target.nodeName === 'INPUT' && target.type === 'radio' && compareTo.nodeName === 'INPUT' && compareTo.type === 'radio') {
    return target.name === compareTo.name;
  }

  return false;
};

var shouldAllowForwardTab = exports.shouldAllowForwardTab = function shouldAllowForwardTab(_ref) {
  var currentElement = _ref.currentElement,
      lastTabbable = _ref.lastTabbable;

  var isAfterLastTabbableElement = nodeIsAfter(currentElement, lastTabbable);
  var isLastTabbableElement = isSameTabbableElement(currentElement, lastTabbable);

  return !isLastTabbableElement && !isAfterLastTabbableElement;
};

var shouldAllowBackwardTab = exports.shouldAllowBackwardTab = function shouldAllowBackwardTab(_ref2) {
  var currentElement = _ref2.currentElement,
      firstTabbable = _ref2.firstTabbable;

  var isBeforeFirstTabbableElement = nodeIsBefore(currentElement, firstTabbable);
  var isFirstTabbableElement = isSameTabbableElement(currentElement, firstTabbable);

  return !isFirstTabbableElement && !isBeforeFirstTabbableElement;
};

/**
 * Higher order component that restricts focus/tabbing to the content with the component
 *
 * @export
 * @param {React.Component} ComposedComponent
 * @returns {React.Component}
 */
function manageFocus(ComposedComponent) {
  var ManageFocus = function (_BcReactComponent) {
    _inherits(ManageFocus, _BcReactComponent);

    function ManageFocus(props) {
      _classCallCheck(this, ManageFocus);

      var _this = _possibleConstructorReturn(this, (ManageFocus.__proto__ || Object.getPrototypeOf(ManageFocus)).call(this, props));

      _this.bindAll('handleKeyDown', 'captureFocus', 'restoreFocus', 'getWrappedInstance');
      _this._focusCaptured = false;
      return _this;
    }

    _createClass(ManageFocus, [{
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        this.restoreFocus();
      }

      /**
       * Traps the focus within the element
       *
       * @param {DOMNode} element
       *
       * @memberOf ManageFocus
       */

    }, {
      key: 'captureFocus',
      value: function captureFocus(element) {
        var restrictFocus = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

        if (this._focusCaptured) {
          // captureFocus should not do anything if the focus is already constrained to the element
          return;
        }

        this._element = _reactDom2.default.findDOMNode(element); // eslint-disable-line react/no-find-dom-node

        if (this._element) {
          this._focusCaptured = true;

          // Store previously focused element and focus the mounted component
          this._previouslyFocusedElement = (0, _utilsAccessibility.getActiveElement)(document);

          if (this.props.handleFocusOnCapture) {
            this.props.handleFocusOnCapture(this._element);
          } else {
            (0, _utilsAccessibility.setFocusWithinElement)(this._element);
          }

          if (restrictFocus) {
            this._element.addEventListener('keydown', this.handleKeyDown);
          }
        }
      }

      /**
       *
       * Releases any focus restrictions and restores focus back to the element that had it before captureFocus was called
       *
       * @memberOf ManageFocus
       */

    }, {
      key: 'restoreFocus',
      value: function restoreFocus(elementToFocusOn) {
        if (!this._focusCaptured) {
          // restoreFocus cannot be called until captureFocus has been called
          return;
        }

        if (this._element) {
          this._element.removeEventListener('keydown', this.handleKeyDown);
        }

        var elementToRestoreFocusTo = elementToFocusOn || this._previouslyFocusedElement;
        if (this.props.handleFocusOnRestore) {
          this.props.handleFocusOnRestore(elementToRestoreFocusTo);
        } else {
          // Restore focus to the previously focused element
          elementToRestoreFocusTo.focus();
        }

        this._element = null;
        this._previouslyFocusedElement = null;
        this._focusCaptured = false;
      }
    }, {
      key: 'handleKeyDown',
      value: function handleKeyDown(e) {
        if (e.keyCode === TAB_KEYCODE) {
          var tabbableElements = (0, _tabbable2.default)(this._element);
          var lastTabbable = _lodash2.default.last(tabbableElements);
          var firstTabbable = _lodash2.default.first(tabbableElements);

          var allowForwardTab = shouldAllowForwardTab({ currentElement: e.target, lastTabbable: lastTabbable });
          var allowBackwardTab = shouldAllowBackwardTab({ currentElement: e.target, firstTabbable: firstTabbable });

          if (!allowForwardTab && !e.shiftKey) {
            // If this is the last tabbable element in the component,
            // we hijack the Tab key and move focus to the first element
            e.preventDefault();
            firstTabbable.focus();
          } else if (!allowBackwardTab && e.shiftKey) {
            // If this is the first tabbable element in the component and they're holding shift,
            // we hijack the key and move focus to the last element
            e.preventDefault();
            lastTabbable.focus();
          }
        }
      }
    }, {
      key: 'getWrappedInstance',
      value: function getWrappedInstance() {
        return this._wrappedComponent;
      }
    }, {
      key: 'render',
      value: function render() {
        var _this2 = this;

        return _react2.default.createElement(ComposedComponent, _extends({}, this.props, {
          captureFocus: this.captureFocus,
          restoreFocus: this.restoreFocus,
          ref: function ref(el) {
            return _this2._wrappedComponent = el;
          } }));
      }
    }]);

    return ManageFocus;
  }(_baseBcReactComponent2.default);

  ManageFocus.propTypes = {
    handleFocusOnCapture: _react.PropTypes.func,
    handleFocusOnRestore: _react.PropTypes.func
  };

  ManageFocus.displayName = 'ManageFocus(' + ComposedComponent.displayName + ')';
  ManageFocus.WrappedComponent = ComposedComponent;

  return ManageFocus;
}


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-accessibility-manage-focus/lib/components/ManageFocus.component.js
// module id = 1010
// module chunks = 1